// Utility to parse drive folder IDs consistently across components
export function parseDriveFolderId(folderId: string) {
  const folderParts = folderId.split('.');
  const folderPrefix = folderParts[0];
  const hasSuffix = folderParts.length > 1;
  const folderSuffix = hasSuffix ? folderParts[1] : undefined;
  const isTrash = folderSuffix === 'trash';
  const isShared = folderSuffix === 'shared';
  const isStarred = folderSuffix === 'starred';
  return {
    folderPrefix,
    hasSuffix,
    folderSuffix,
    isTrash,
    isShared,
    isStarred,
  };
}
